import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'application_list.title',
    defaultMessage: 'Application list',
    description: 'Title of the application list page',
  },
  createLink: {
    id: 'application_list.create_link',
    defaultMessage: 'Create',
    description: 'Label of the create link button',
  },
  genericError: {
    id: 'application_list.error.generic',
    defaultMessage: 'An error occurred',
    description: 'Generic error message',
  },
  noCustomerFound: {
    id: 'application_list.error.not_found',
    defaultMessage: 'No applications found for your search',
    description: 'No application found message',
  },
  stateColumn: {
    id: 'application_list.table_head.state',
    defaultMessage: 'State',
    description: 'Title of the state column',
  },
  createdAtColumn: {
    id: 'application_list.table_head.created_at',
    defaultMessage: 'Created at',
    description: 'Title of the created at column',
  },
  referenceColumn: {
    id: 'application_list.table_head.folder_id',
    defaultMessage: 'Folder reference',
    description: 'Title of the folder id column',
  },
  teamColumn: {
    id: 'application_list.table_head.team',
    defaultMessage: 'Team',
    description: 'Title of the team column',
  },
  applicationCreatorColumn: {
    id: 'application_list.table_head.application_creator',
    defaultMessage: 'Application creator',
    description: 'Title of the application creator column',
  },
  partnersColumn: {
    id: 'application_list.table_head.partners',
    defaultMessage: 'Partners',
    description: 'Title of the partners column',
  },
  statusColumn: {
    id: 'application_list.table_head.status',
    defaultMessage: 'Status',
    description: 'Title of the status column',
  },
  anonymousCustomer: {
    id: 'application_list.tooltip.anonymous_customer',
    defaultMessage: 'This application is no longer available for consultation',
    description: 'tooltip message for a anonymous customer',
  },
  numberOfApplications: {
    id: 'application_list.applications_number',
    defaultMessage: '{number} {number, plural, =0 {applications} one {application} other {applications}}',
    description: 'Number of applications',
  },
  allApplications: {
    id: 'application_list.all_applications',
    defaultMessage: 'Show all aplications',
    description: 'Display all applications',
  },
});
export const downloadMessages = defineMessages({
  exportDates: {
    id: 'application.download_menu.export_dates',
    defaultMessage: 'Export by dates',
    description: 'Label of export by dates button',
  },
  exportAll: {
    id: 'application.download_menu.export_all',
    defaultMessage: 'Export all',
    description: 'Label of export all button',
  },
});
